import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Form from 'react-jsonschema-form-bs4';
import { JSONSchema6 } from 'json-schema';
import { fetchApi } from '../../services/api';
import { IDName } from '../Accounts/Payments';
import JsonEditor from './jsonEditor';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import FormsErrorBoundary from './FormsErrorBoundary';
import Address from './fields/address';
import Healthcard from './fields/healthcard';
import Phone from './fields/phone';
import DateInput from './fields/date';
import TimeInput from './fields/time';
import arrayFieldTemplate from './arrayFieldTemplate';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>

type State = {
    form: FormData | null;
    type: number;
}

type FormData = {
    FormId: number;
    JsonSchema: JSONSchema6;
    JsonUISchema: JSONSchema6;
}

export default class Forms extends React.Component<Props, State>{

    private readonly types: IDName[] = [
        { ID: 0, Name: 'Account' },
        { ID: 1, Name: 'Child' },
        { ID: 2, Name: 'Medical' },
        { ID: 3, Name: 'Academic' },
        { ID: 4, Name: 'Guardian' },
        { ID: 5, Name: 'Release' }
    ];

    constructor(props: Props) {
        super(props);

        this.state = {
            form: null,
            type: 0
        }

        this.get = this.get.bind(this);
        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        this.get(this.state.type);
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title='Customize Forms' />
            <div className="row">
                <div className="col">
                    <h1>Customize Forms</h1>
                </div>
                <div className="col">
                    <DropDownList
                        data={this.types}
                        textField="Name"
                        className="float-right"
                        value={this.types.find(x => x.ID === this.state.type)}
                        onChange={(e) => {
                            this.setState({ type: e.target.value.ID, form: null }, () => {
                                this.get(this.state.type);
                            });
                        }}
                    />
                </div>
            </div>
            {this.state.form && <div className="row">
                <div className="col-xl-6">
                    <label>Schema</label>
                    <JsonEditor
                        json={this.state.form.JsonSchema}
                        onChange={(json) => this.updateForm({ JsonSchema: json })}
                    />
                    <label>UI Schema</label>
                    <JsonEditor
                        json={this.state.form.JsonUISchema}
                        onChange={(json) => this.updateForm({ JsonUISchema: json })}
                    />
                </div>
                <div className="col-xl-6">
                    <FormsErrorBoundary>
                        <Form
                            showErrorList={false}
                            schema={this.state.form.JsonSchema}
                            uiSchema={this.state.form.JsonUISchema}
                            fields={{ address: Address, healthcard: Healthcard, date: DateInput, time: TimeInput, phone: Phone }}
                            onSubmit={(e) => console.log(e.formData)}
                            ArrayFieldTemplate={(props) => arrayFieldTemplate(props, this.onRemove)}
                        >
                            <button type="submit" className="btn btn-primary">Test Save</button>
                        </Form>
                    </FormsErrorBoundary>
                </div>
            </div>}
            <br />
            <button onClick={this.save} className="btn btn-primary">Update Form</button>
            <br />
            <br />
        </React.Fragment>
    }

    private get(formType: number) {
        fetchApi(`api/Form/Get/${formType}`)
            .then((response: { FormId: number, JsonSchema: any, JsonUISchema: any }) => {
                response.JsonSchema = JSON.parse(response.JsonSchema);
                response.JsonUISchema = JSON.parse(response.JsonUISchema);
                this.setState({ form: response });
            });
    }

    private async save() {
        if (this.state.form && confirm(`Are you sure you want to update this form?`)) {
            const data = {
                FormID: this.state.form.FormId,
                JsonSchema: JSON.stringify(this.state.form.JsonSchema, null, 2),
                JsonUISchema: JSON.stringify(this.state.form.JsonUISchema, null, 2)
            }
            await fetchApi(`api/Form/Save`, data, 'POST');
        }
    }

    private updateForm(value: Partial<FormData>): void {
        const form = Object.assign({}, this.state.form, value);
        this.setState({ form });
    }

    private onRemove(index: number): Promise<Boolean> {
        if (confirm("Are you sure?")) {
            return Promise.resolve(true);
        }

        return Promise.resolve(false);
    }
}
